(function () {
  'use strict';

  window.GiftenAddItemCart = function (variantId) {
    const formData = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then(() => {
        setTimeout(function () {
          const cartLink = document.querySelector('.cart-link');
          if (cartLink) {
            cartLink.click();
          }
          fetch(theme.routes.cart)
            .then((response) => response.json())
            .then((cart) => {
              document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: cart.items
              }));
            });
        }, 400);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const giftBox = new theme.Modals('GiftBoxPopup', 'giftbox-popup-modal', {
    closeOffContentClick: false,
    bodyOpenClass: ['modal-open', 'giftbox-modal-open']
  });

  function addGiftbox() {
    const addBtn = document.querySelector('.js-add-giftbox');
    if (!addBtn) return;

    const drawer = new theme.Drawers('CartDrawer', 'cart');

    addBtn.addEventListener('click', () => {
      const variantID = parseInt(addBtn.getAttribute('data-variant-id'), 10);
      const formData = {
        items: [{
          id: variantID,
          quantity: 1
        }]
      };

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 422) {
            console.log('error adding to cart', data);
          } else {
            document.dispatchEvent(new CustomEvent('cart:build'));
            if (document.body.classList.contains('template-cart')) {
              giftBox.close();
            } else {
              drawer.open();
            }
          }
        });
    });
  }

  function cancelGiftbox() {
    const cancelBtn = document.querySelector('.js-cancel-giftbox');
    if (!cancelBtn) return;

    cancelBtn.addEventListener('click', () => {
      const popup = document.querySelector('#GiftBoxPopup');
      const expiryTimes = parseInt(popup.getAttribute('data-delay-times'), 10) * 1000;
      const expiry = new Date(new Date().getTime() + expiryTimes);

      Cookies.set('giftbox-popup', 'cancel', { path: '/', expires: expiry });
    });
  }

  function giftBoxModal() {
    giftBox.open();
    addGiftbox();
    cancelGiftbox();
  }

  function openGiftBox(cartItems) {
    const vendorCompare = ['Giften', 'Giften Market'];
    const giftBoxSKU = 'BYOGB20';
    const giftBoxCookie = Cookies.get('giftbox-popup');
    let totalQty = 0;
    let hasGiftBox = false;

    for (const key in cartItems) {
      if (Object.hasOwnProperty.call(cartItems, key)) {
        const cartItem = cartItems[key];
        const itemVendor = cartItem.vendor;
        const itemSKU = cartItem.sku;
        const itemQty = cartItem.quantity;

        if (!vendorCompare.includes(itemVendor) && itemSKU !== giftBoxSKU) {
          totalQty += itemQty;
        }

        if (itemSKU === giftBoxSKU) {
          hasGiftBox = true;
        }
      }
    }

    if (totalQty >= 3 && !hasGiftBox && !giftBoxCookie) {
      giftBoxModal();
    }
  }

  function giftBoxOnLoad() {
    fetch(theme.routes.cart)
      .then((response) => response.json())
      .then((cart) => openGiftBox(cart.items));
  }

  if (window.location.pathname === '/cart') {
    giftBoxOnLoad();
  }

  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(giftBoxOnLoad, 1400);
  });

  document.addEventListener('cart:build', function () {
    setTimeout(giftBoxOnLoad, 1400);
  });

  document.addEventListener('cart:updated', function (evt) {
    openGiftBox(evt.detail.cart.items);
  });
})();
